exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".treatments-summary{background-color:var(--theme-grey-bg);padding:10px;margin:15px 0}.treatments-summary__items{margin:5px 0;padding:5px 0;border-top:1px solid var(--theme-grey);border-bottom:1px solid var(--theme-grey)}", ""]);

// exports
